"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator_loading = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageGameMode_tutorial_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_tutorial-sidecar");
var voyageMissionData_1 = require("@voyage/missions/voyageMissionData");
var voyageShipSaver_sidecar_1 = require("@voyage/saver/voyageShipSaver-sidecar");
var voyageTestParams_sidecar_1 = require("@voyage/scene/voyageTestParams-sidecar");
var crokinoleUi_menu_main_sidecar_1 = require("proto/crokinole/ui-menus/crokinoleUi_menu_main-sidecar");
var namespace = 'voyage-loading';
function generator_loading() {
    var startingShip, tm;
    return __generator(this, function (_a) {
        console.log(namespace, 'loading game!!');
        startingShip = 'small' // 'voyage
        ;
        if (!voyageTestParams_sidecar_1.voyageTestParams.isDevMode) {
            voyageShipSaver_sidecar_1.voyageShipSaver.load(startingShip);
            voyageGameManager_sidecar_1.voyageGameManager.goMenuMain();
        }
        else {
            tm = voyageTestParams_sidecar_1.voyageTestParams.testMode;
            // voyageShipSaver.load(settings.get().filename || startingShip)
            if (tm === 'normal') {
                voyageGameManager_sidecar_1.voyageGameManager.goMenuMain();
            }
            else if (tm === 'editor') {
                voyageGameManager_sidecar_1.voyageGameManager.goEditor();
            }
            else if (tm === 'game') {
                websockets_sidecar_1.websockets.setSingleplayer(true);
                voyageGameManager_sidecar_1.voyageGameManager.goScenario_reloaded_continue_game();
                // voyageGameMode_tutorial.signalSkip(true)
            }
            else if (tm === 'gen-test') {
                websockets_sidecar_1.websockets.setSingleplayer(true);
                voyageGameManager_sidecar_1.voyageGameManager.goScenario_reloaded_continue_game();
                // voyageGameMode_tutorial.signalSkip(true)
            }
            else if (tm === 'crokinole') {
                websockets_sidecar_1.websockets.setSingleplayer(true);
                // voyageGameManager.goScenario_crokinole()
                // voyageGameMode_tutorial.signalSkip(true)
            }
            else if (tm === 'crokinole-main-menu') {
                // websockets.setSingleplayer(true)
                voyageGameManager_sidecar_1.voyageGameManager.goMenuMain();
                crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.setOpen('main-menu');
                // voyageGameMode_tutorial.signalSkip(true)
            }
            else if (tm === 'body-align') {
                voyageGameManager_sidecar_1.voyageGameManager.goBodyAlign();
            }
            else if (tm === 'test') {
                websockets_sidecar_1.websockets.setSingleplayer(true);
                voyageGameManager_sidecar_1.voyageGameManager.goScenario_new();
                // voyageGameMode_tutorial.signalSkip(true)
                voyageGameManager_sidecar_1.voyageGameManager.addAfterLoad(function () {
                    voyageGameStatus_sidecar_1.voyageGameStatus.setMission(voyageMissionData_1.EVoyageMissionType.Test1);
                    //voyageGameStatus.setMission(EVoyageMissionType.FightAliens2)
                });
                // TODO: load test mission
            }
            else if (tm === 'mp-test') {
                websockets_sidecar_1.websockets.setSingleplayer(false);
                // voyageGameManager.goGame()
            }
            else {
                if (voyageTestParams_sidecar_1.voyageTestParams.singleplayerAutoJoin) {
                    websockets_sidecar_1.websockets.setSingleplayer(true);
                    voyageGameManager_sidecar_1.voyageGameManager.goGame();
                    voyageGameMode_tutorial_sidecar_1.voyageGameMode_tutorial.signalSkip(true);
                }
                else {
                    voyageGameManager_sidecar_1.voyageGameManager.goMenuMain();
                }
            }
        }
        return [2 /*return*/, 0];
    });
}
exports.generator_loading = generator_loading;
